import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { useGetCommonStore } from '@/store';
import { commonButtonProps } from './helpers';

import { ScBonusCardButtons } from './styled';

interface IBonusCardButtons {
  isPending: boolean;
  activatable: boolean;
  cancelable: boolean;
  handleActivate: () => void;
  handlePlay: () => void;
  isBonusType: boolean;
  id: number;
}

export const BonusCardButtons: FC<IBonusCardButtons> = ({
  isPending,
  activatable,
  cancelable,
  handleActivate,
  handlePlay,
  isBonusType,
  id,
}) => {
  const { t } = useTranslation('bonuses');
  const useCommonStore = useGetCommonStore();

  return (
    <ScBonusCardButtons>
      {activatable ? (
        <Button
          onClick={handleActivate}
          primary
          {...commonButtonProps(isPending)}
        >
          {t('activate')}
        </Button>
      ) : (
        <Button onClick={handlePlay} primary {...commonButtonProps(isPending)}>
          {t('play')}
        </Button>
      )}
      {cancelable && (
        <Button
          onClick={() => {
            useCommonStore.setState({
              currentCancelBonusData: { isBonusType, id },
            });
          }}
          whiteTransparent
          {...commonButtonProps(isPending)}
        >
          {t('cancel')}
        </Button>
      )}
    </ScBonusCardButtons>
  );
};
